import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class SearchButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.general.searchButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M32,29.17L20.06,17.23a11,11,0,1,0-2.83,2.83L29.17,32ZM3,11a8,8,0,1,1,8,8A8,8,0,0,1,3,11Z" />
				</svg>
			</i>
		</Button>;
	}
}
